<template>
    <v-container fluid class="content-page" :class="{ 'content-page--wide': wide }">
        <v-card class="content-page__card rounded-lg">
            <header class="content-page__header">
                <span class="content-page__icon custom-orange">
                    <v-icon color="white">{{ icon }}</v-icon>
                </span>
                <div class="content-page__heading">
                    <h1 class="content-page__title">{{ title }}</h1>
                    <div v-if="subtitle" class="content-page__subtitle">{{ subtitle }}</div>
                </div>
                <div class="content-page__actions">
                    <slot name="actions" />
                </div>
            </header>
            <div class="content-page__divider custom-orange" />

            <v-skeleton-loader v-if="loading" type="paragraph, paragraph, paragraph" />
            <div v-else class="content-page__body">
                <slot />
            </div>
        </v-card>
    </v-container>
</template>

<script>
    // Shared reading layout for the "Διοργάνωση" pages
    export default {
        props: {
            title: {
                type: String,
                required: true
            },
            subtitle: {
                type: String,
                default: null
            },
            icon: {
                type: String,
                default: 'mdi-information-outline'
            },
            loading: {
                type: Boolean,
                default: false
            },
            wide: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>
.content-page {
    max-width: 860px;
    margin: 0 auto;
}

.content-page--wide {
    max-width: 1200px;
}

.content-page__card {
    padding: 28px 36px 36px;
    text-align: left;
}

.content-page__header {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 14px;
}

.content-page__icon {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 10px;
}

.content-page__heading {
    flex: 1 1 auto;
    min-width: 0;
}

.content-page__title {
    font-size: 1.9rem;
    font-weight: 800;
    line-height: 1.2;
}

.content-page__subtitle {
    margin-top: 2px;
    color: rgba(0, 0, 0, 0.55);
    font-family: Ubuntu, Arial, sans-serif;
    font-size: 0.95rem;
    font-weight: 500;
}

.content-page__actions:empty {
    display: none;
}

.content-page__divider {
    width: 64px;
    height: 4px;
    margin: 16px 0 24px;
    border-radius: 2px;
}

/* ---------- Rich text coming from the CMS ---------- */
.content-page__body {
    font-family: Ubuntu, Arial, sans-serif !important;
    font-size: 17px;
    line-height: 1.75;
    color: rgba(0, 0, 0, 0.85);
    overflow-wrap: anywhere;
}

.content-page__body ::v-deep p {
    margin-bottom: 1em;
}

.content-page__body ::v-deep h1,
.content-page__body ::v-deep h2,
.content-page__body ::v-deep h3,
.content-page__body ::v-deep h4 {
    margin: 1.6em 0 0.6em;
    line-height: 1.3;
    font-weight: 700;
}

.content-page__body ::v-deep h2 {
    padding-left: 12px;
    border-left: 4px solid #ff7133;
}

.content-page__body ::v-deep ul,
.content-page__body ::v-deep ol {
    margin-bottom: 1em;
    padding-left: 1.4em;
}

.content-page__body ::v-deep li {
    margin-bottom: 0.4em;
}

.content-page__body ::v-deep li::marker {
    color: #ff7133;
}

.content-page__body ::v-deep a {
    color: #ef4444;
    font-weight: 600;
}

.content-page__body ::v-deep strong {
    color: #111;
}

.content-page__body ::v-deep img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
}

.content-page__body ::v-deep table {
    display: block;
    width: 100%;
    overflow-x: auto;
    border-collapse: collapse;
}

.content-page__body ::v-deep td,
.content-page__body ::v-deep th {
    padding: 6px 10px;
    border: 1px solid rgba(0, 0, 0, 0.12);
}

@media (max-width: 600px) {
    .content-page__card {
        padding: 20px 16px 24px;
    }

    .content-page__title {
        font-size: 1.45rem;
    }

    .content-page__body {
        font-size: 16px;
    }
}
</style>
